module.exports = __webpack_public_path__ + "videos/shixiao_mobile.a9b6b6af.mp4";